import { recognize, setLogging } from 'tesseract.js';

setLogging(false);

const DOC_PATTERNS = {
  AADHAAR: /(\d{4}\s?\d{4}\s?\d{4})/g,
  PAN: /[A-Z]{5}[0-9]{4}[A-Z]/g,
  VOTER_ID: /[A-Z]{3}[0-9]{7}/g,
  DRIVING_LICENSE: /[A-Z]{2}[-\s]?[0-9]{13}/g,
};

const VALIDATORS = {
  AADHAAR: (num) => /^\d{12}$/.test(num.replace(/\s/g, '')),
  PAN: (num) => /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(num),
  VOTER_ID: (num) => /^[A-Z]{3}[0-9]{7}$/.test(num),
  DRIVING_LICENSE: (num) => /^[A-Z]{2}[-\s]?[0-9]{13}$/.test(num),
  GSTIN: (num) => /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(num),
  CIN: (num) => /^([LUu]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/.test(num),
};

const DOB_PATTERNS = [
  /\b(\d{2}[/-]\d{2}[/-]\d{4})\b/g,
  /\b(\d{4}[/-]\d{2}[/-]\d{2})\b/g,
];

const NAME_HINTS = ['Name', 'NAME', 'Applicant', 'Holder'];

export async function ocrExtractText(imageFile) {
  const { data } = await recognize(imageFile, 'eng', {
    logger: () => {},
  });
  return data.text;
}

export function extractDocumentNumber(text, docType) {
  const pattern = DOC_PATTERNS[docType];
  if (!pattern) return null;
  const matches = text.match(pattern);
  if (!matches) return null;
  const cleaned = matches.map((m) => m.replace(/\s/g, ''));
  return cleaned[0] || null;
}

export function validateDocumentNumber(number, docType) {
  const validator = VALIDATORS[docType];
  if (!validator) return false;
  return validator(number);
}

export function extractDOB(text) {
  for (const pattern of DOB_PATTERNS) {
    const matches = text.match(pattern);
    if (matches && matches.length > 0) {
      return matches[0];
    }
  }
  return null;
}

export function extractName(text) {
  const lines = text.split('\n').map((l) => l.trim()).filter(Boolean);
  for (const hint of NAME_HINTS) {
    for (const line of lines) {
      if (line.includes(hint)) {
        const parts = line.split(':');
        if (parts.length > 1) {
          return parts[1].trim();
        }
        const idx = line.indexOf(hint);
        return line.substring(idx + hint.length).trim();
      }
    }
  }
  for (const line of lines) {
    if (/^[A-Z][a-z]+(\s[A-Z][a-z]+){1,3}$/.test(line) && line.length > 5) {
      return line;
    }
  }
  return null;
}

export function extractGender(text) {
  const genderMatch = text.match(/\b(Male|Female)\b/i);
  return genderMatch ? genderMatch[1] : null;
}

export async function extractAllFromImage(imageFile, docType) {
  const text = await ocrExtractText(imageFile);
  const docNumber = extractDocumentNumber(text, docType);
  return {
    rawText: text,
    docNumber,
    isValid: docNumber ? validateDocumentNumber(docNumber, docType) : false,
    name: extractName(text),
    dob: extractDOB(text),
    gender: extractGender(text),
  };
}

export const DOCUMENT_TYPES = [
  { value: 'AADHAAR', label: 'Aadhaar Card' },
  { value: 'PAN', label: 'PAN Card' },
  { value: 'VOTER_ID', label: 'Voter ID' },
  { value: 'DRIVING_LICENSE', label: 'Driving License' },
  { value: 'GSTIN', label: 'GSTIN Certificate' },
  { value: 'CIN', label: 'CIN Certificate' },
];
